'use client';

import { NotFound } from './NotFound';
import { NotFoundBgLayout } from '@/components/layout/NotFoundBgLayout';

export const NotFoundScreen = () => {
  return (
    <NotFoundBgLayout>
      <NotFound />
    </NotFoundBgLayout>
  );
};
